const ERROR_MESSAGES = {
  UPDATE_PERSONAL_INFORMATION:
    'Unfortunately, we were unable to update your personal information at this time. Please try again later.',
  UPDATE_PERSONAL_INFORMATION_TIMEOUT:
    'Unfortunately, we were unable to update your personal information at this time. Please try again in a few minutes.',
  UPDATE_ADDRESS:
    'Unfortunately, we were unable to update your address at this time. Please try again later.',
  UPDATE_ADDRESS_UNVERIFIED:
    'Unfortunately, we were unable to verify your address. Please check that your information is accurate.',
  UPDATE_ADDRESS_TIMEOUT:
    'Unfortunately, we were unable to update your address at this time. Please try again in a few minutes.',
  UPDATE_EMAIL_IN_USE: 'Email is already in use.',
  GET_PERSONAL_DETAILS_TIMEOUT:
    'Unfortunately, we were unable to retrieve your personal information at this time. Please try again later.',
  UPDATE_CONTACT_DETAILS_ERROR:
    'Unfortunately, we were unable to update your information at this time. Please try again later.',
  GET_USER_PROFILE_DATA_TIMEOUT:
    'Unfortunately, we were unable to retrieve your user preferences at this time. Please try again later.',
  UPDATE_USER_PROFILE_DATA:
    'Unfortunately, we were unable to update your user preferences at this time. Please try again later.',
  UPDATE_USER_PROFILE_DATA_TIMEOUT:
    'Unfortunately, we were unable to update your user preferences at this time. Please try again in a few minutes.'
};

export default ERROR_MESSAGES;
